import { useLocation } from "react-router";

export const useBulkExportFavouriteQueryParams = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const favoriteBulkId = params.has("favourite") ? Number(params.get("favourite")) : undefined;
  const favoriteSavedId = params.has("savedFavourite") ? Number(params.get("savedFavourite")) : undefined;
  return { favoriteBulkId, favoriteSavedId };
};
